import React, { useEffect, useState } from "react";
import Sidebarlayout from "../../Layouts/Sidebarlayout";
import "../../Assets/Css/ViewShareHolder.scss";
import UserAvatar from "react-user-avatar";
import Tab from "react-bootstrap/Tab";
import Table from "../../Components/Table";
import Chart from "../../Components/Chart";
import Nav from "react-bootstrap/Nav";
import { HiOutlineMail } from "react-icons/hi";
import { BiPhoneCall } from "react-icons/bi";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getShareholders } from "../../Services/Shareholders/action";
import { toast } from 'react-toastify'
import moment from "moment";


const ViewShareHoldersGroup = () => {

    const [groupedShareholders, setGroupedShareholders] = useState({});

    const location = useLocation();
    const navigate = useNavigate();
    let sholderId = location.state?.sholderId;
    let groupeddata = location.state?.data;
    useEffect(() => {
        if (!groupeddata) {
            toast.error("Something went wrong");
            navigate("/shareholder/group");
        }
        setGroupedShareholders(groupeddata);
    }, []);

    // Fetching Data  
    const shareholderData = groupeddata[sholderId];
    console.log(shareholderData, "shareholderData");

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getShareholders());
    }, []);

    let data = { shId: sholderId };

    const headerTransaction = [
        { field: "Sr No" },
        { field: "Type" },
        { field: 'Transaction Amount' },
        { field: "Sharing Amount" },
        { field: "Description" },
        { field: "Invoices" },
        { field: "Date" },
    ];

    const transactionData = shareholderData?.flatMap((shareholder, index) => {
        return shareholder?.shareHolderTransactionMap?.sort((a, b) => moment(a.transactionShareHolderMap.transaction_date).isBefore(moment(b.transactionShareHolderMap.transaction_date)) ? 1 : -1)?.map((item, ind) => {
            const invoices = item?.transactionShareHolderMap?.transactionInvoiceMap?.map((item) => ({ id: item.invoice_id }));
            console.log(shareholder, "<This is invoices");
            return {
                "Sr No": {
                    value: ind + 1,
                    type: "text",
                },
                Type: {
                    value: item?.transactionShareHolderMap?.type,
                    type: item?.transactionShareHolderMap?.type.toLowerCase(),
                },
                Description: {
                    value: item?.transactionShareHolderMap?.description,
                    type: "description",
                },
                'Sharing Amount': {
                    value: `₹${item?.amount}`,
                    type: "amount",
                },
                'Transaction Amount': {
                    value: `₹${item?.transactionShareHolderMap?.amount}`,
                    type: "amount",
                },
                Invoices: {
                    value: invoices,
                    type: "invoices",
                },
                Date: {
                    value: item?.transactionShareHolderMap?.transaction_date.split(" ")[0],
                    type: "date",
                },
                Action: {
                    value: "/transaction/edit",
                    value2: "/transaction/view",
                    type: "action",
                },
            };
        });
    });

    const monthwisedata = {};

    shareholderData?.map((shareholder, index) => {
        return shareholder?.shareHolderTransactionMap?.forEach((transcation) => {
            const { amount, transactionShareHolderMap: { transaction_date } } = transcation;
            const type = transcation?.transactionShareHolderMap?.type;
            const month = `${new Date(transaction_date).getMonth()}-${new Date(transaction_date).getFullYear()}`;
            console.log(month, ' <== month')
            if (!monthwisedata[month]) {
                monthwisedata[month] = {
                    month: month,
                    Expense: 0,
                    Earnings: 0,
                };
            }
            if (type === "debit") {
                monthwisedata[month].Expense += parseFloat(parseFloat(amount).toFixed(2));
            } else if (type === "credit") {
                monthwisedata[month].Earnings += parseFloat(parseFloat(amount).toFixed(2));
            }
        });
    });

    const resultArray = Array.from({ length: 12 }, (_, i) => {
        // const monthName = new Date(new Date().setMonth(i)).toLocaleString(
        //   "default",
        //   { month: "short" }
        // );
        const monthName = moment().subtract(i, 'months').format('MMM YYYY')
        const monthToFetchData = `${moment().subtract(i, 'months').toDate().getMonth()}-${moment().subtract(i, 'months').toDate().getFullYear()}`
        const data = monthwisedata[monthToFetchData] || {
            month: monthName,
            Expense: 0,
            Earnings: 0,
        };
        return { name: monthName, Expense: data.Expense, Earnings: data.Earnings };
    }).reverse();

    const headerClient = [
        { field: "Client" },
        { field: "Country" },
        { field: "Mobile" },
        { field: "Managed By" },
    ];

    const clientData = shareholderData?.flatMap((shareholder, index) => {
        return shareholder?.managedBy?.map((client, index) => {
            return {
                Client: {
                    value: client.name,
                    value2: client.email,
                    src: "",
                    type: "client",
                },
                "Managed By": {
                    value: shareholder.name,
                    value2: shareholder.email,
                    src: "",
                    type: "client",
                },
                Address: {
                    value: client.address1,
                    value2: client.address2,
                    city: client.city,
                    state: client.state,
                    country: client.country,
                    postalcode: client.postalcode,
                    type: "address",
                },
                Country: {
                    value: client.country,
                    type: "text",
                },
                Mobile: {
                    value: client.mobile,
                    type: "text",
                },
                "Share Holders": {
                    value: [{ name: "Sh 1" }, { name: "Sh 2" }, { name: "Sh 3" }],
                    type: "share holder",
                },
                Action: {
                    value: "/client/edit",
                    value2: "/client/view",
                    type: "action",
                },
            };
        });
    });

    return (
        <Sidebarlayout>
            <div className="viewShareHolder-main">
                <div className="page-title">
                    <h4>View Share Holders Group</h4>
                    <div className="edit-btn">
                        <button type="button" className="custom-btn">
                            <Link
                                to="/shareholder/edit"
                                style={{ textDecoration: "inherit", color: "inherit" }}
                                state={{ data: data }}
                            >
                                Edit
                            </Link>
                        </button>
                    </div>
                </div>
                <div className="row mainRow">
                    <div className="col-lg-4">

                        {Array.isArray(groupedShareholders[sholderId]) && groupedShareholders[sholderId].length > 0 ? (
                            groupedShareholders[sholderId].map((shareholder, index) => (
                                <><div className="left-part">
                                    <div className="image-div">
                                        <UserAvatar
                                            size="100"
                                            src={""}
                                            name={shareholder?.name || "-"}
                                        />
                                    </div>
                                    <div className="details-content">
                                        <h6 className="label">Name</h6>
                                        <h6 className="value">{shareholder?.name}</h6>
                                    </div>
                                    <div className="details-content">
                                        <h6 className="label">Role</h6>
                                        <h6 className="value">{shareholder?.role?.name}</h6>
                                    </div>
                                    <div className="details-content">
                                        <h6 className="label">Balance</h6>
                                        <h6 className="value">₹{shareholder?.balance || 0}</h6>
                                    </div>
                                    <div className="details-content">
                                        <h6 className="label">{<BiPhoneCall />}</h6>
                                        <h6 className="value">{shareholder?.mobile}</h6>
                                    </div>
                                    <div className="details-content">
                                        <h6 className="label">{<HiOutlineMail />}</h6>
                                        <h6 className="value">{shareholder?.email}</h6>
                                    </div>
                                </div > </>
                            ))
                        ) : (
                            <p>No Shareholders in this group</p>
                        )}

                    </div>
                    <div className="col-lg-8">
                        <div className="parent-container">
                            <div className="tabs-bar">
                                <Tab.Container
                                    id="left-tabs-example"
                                    defaultActiveKey="Transactions"
                                    className="navbar"
                                >
                                    <Nav variant="pills" className="flex-row">
                                        <Nav.Item>
                                            <Nav.Link eventKey="Transactions">Transactions</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="Clients">Clients</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                    <Tab.Content>
                                        <Tab.Pane eventKey="Transactions">
                                            <Table
                                                header={headerTransaction}
                                                data={transactionData || []}
                                                footer={false}
                                            />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="Clients">
                                            <Table
                                                header={headerClient}
                                                data={clientData || []}
                                                footer={false}
                                            />
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Tab.Container>
                            </div>
                            <div className="shareholder-stats">
                                <h6 className="heading-title">Statistics</h6>
                                <div className="chart-div">
                                    <div className="chart">
                                        <Chart data={resultArray} />
                                    </div>
                                    <div className="chart-label">
                                        <div className="label-1">
                                            <div className="label-circle-ear"></div>
                                            <div className="label-text-ear">Earnings</div>
                                        </div>
                                        <div className="label-1">
                                            <div className="label-circle-exp"></div>
                                            <div className="label-text-exp">Expense</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Sidebarlayout>
    );
};

export default ViewShareHoldersGroup;
